module.exports = __webpack_public_path__ + "img/carPesquisa.dcc17474.svg";